// export const defaultEditorContent = {
//   type: "doc",
//   content: [
//     {
//       type: "heading",
//       attrs: { level: 2 },
//       content: [{ type: "text", text: "AlphaPass EPPP Notes" }],
//     },
//     {
//       type: "paragraph",
//       content: [
//         {
//           type: "text",
//           text: "Welcome to AlphaPass EPPP Notes - Your comprehensive study companion for the EPPP examination.",
//         },
//       ],
//     },
//     {
//       type: "heading",
//       attrs: { level: 3 },
//       content: [{ type: "text", text: "Getting Started" }],
//     },
//     {
//       type: "codeBlock",
//       attrs: { language: null },
//       content: [{ type: "text", text: "npm i novel" }],
//     },
//     {
//       type: "heading",
//       attrs: { level: 3 },
//       content: [{ type: "text", text: "Usage" }],
//     },
//     {
//       type: "codeBlock",
//       attrs: { language: null },
//       content: [
//         {
//           type: "text",
//           text: 'import { Editor } from "novel";\n\nexport default function App() {\n  return (\n     <Editor />\n  )\n}',
//         },
//       ],
//     },
//     {
//       type: "heading",
//       attrs: { level: 3 },
//       content: [{ type: "text", text: "Features" }],
//     },
//     {
//       type: "orderedList",
//       attrs: { tight: true, start: 1 },
//       content: [
//         {
//           type: "listItem",
//           content: [
//             {
//               type: "paragraph",
//               content: [{ type: "text", text: "Slash menu & bubble menu" }],
//             },
//           ],
//         },
//         {
//           type: "listItem",
//           content: [
//             {
//               type: "paragraph",
//               content: [
//                 { type: "text", text: "AI autocomplete (type " },
//                 { type: "text", marks: [{ type: "code" }], text: "++" },
//                 {
//                   type: "text",
//                   text: " to activate, or select from slash menu)",
//                 },
//               ],
//             },
//           ],
//         },
//         {
//           type: "listItem",
//           content: [
//             {
//               type: "paragraph",
//               content: [
//                 {
//                   type: "text",
//                   text: "Image uploads (drag & drop / copy & paste, or select from slash menu) ",
//                 },
//               ],
//             },
//           ],
//         },
//         {
//           type: "listItem",
//           content: [
//             {
//               type: "paragraph",
//               content: [
//                 {
//                   type: "text",
//                   text: "Add tweets from the command slash menu:",
//                 },
//               ],
//             },
//             {
//               type: "twitter",
//               attrs: {
//                 src: "https://x.com/elonmusk/status/1800759252224729577",
//               },
//             },
//           ],
//         },
//         {
//           type: "listItem",
//           content: [
//             {
//               type: "paragraph",
//               content: [
//                 {
//                   type: "text",
//                   text: "Mathematical symbols with LaTeX expression:",
//                 },
//               ],
//             },
//             {
//               type: "orderedList",
//               attrs: {
//                 tight: true,
//                 start: 1,
//               },
//               content: [
//                 {
//                   type: "listItem",
//                   content: [
//                     {
//                       type: "paragraph",
//                       content: [
//                         {
//                           type: "math",
//                           attrs: {
//                             latex: "E = mc^2",
//                           },
//                         },
//                       ],
//                     },
//                   ],
//                 },
//                 {
//                   type: "listItem",
//                   content: [
//                     {
//                       type: "paragraph",
//                       content: [
//                         {
//                           type: "math",
//                           attrs: {
//                             latex: "a^2 = \\sqrt{b^2 + c^2}",
//                           },
//                         },
//                       ],
//                     },
//                   ],
//                 },
//                 {
//                   type: "listItem",
//                   content: [
//                     {
//                       type: "paragraph",
//                       content: [
//                         {
//                           type: "math",
//                           attrs: {
//                             latex:
//                               "\\hat{f} (\\xi)=\\int_{-\\infty}^{\\infty}f(x)e^{-2\\pi ix\\xi}dx",
//                           },
//                         },
//                       ],
//                     },
//                   ],
//                 },
//                 {
//                   type: "listItem",
//                   content: [
//                     {
//                       type: "paragraph",
//                       content: [
//                         {
//                           type: "math",
//                           attrs: {
//                             latex:
//                               "A=\\begin{bmatrix}a&b\\\\c&d \\end{bmatrix}",
//                           },
//                         },
//                       ],
//                     },
//                   ],
//                 },
//                 {
//                   type: "listItem",
//                   content: [
//                     {
//                       type: "paragraph",
//                       content: [
//                         {
//                           type: "math",
//                           attrs: {
//                             latex: "\\sum_{i=0}^n x_i",
//                           },
//                         },
//                       ],
//                     },
//                   ],
//                 },
//               ],
//             },
//           ],
//         },
//       ],
//     },
//     {
//       type: "image",
//       attrs: {
//         src: "https://public.blob.vercel-storage.com/pJrjXbdONOnAeZAZ/banner-2wQk82qTwyVgvlhTW21GIkWgqPGD2C.png",
//         alt: "banner.png",
//         title: "banner.png",
//         width: null,
//         height: null,
//       },
//     },
//     { type: "horizontalRule" },
//     {
//       type: "heading",
//       attrs: { level: 3 },
//       content: [{ type: "text", text: "Learn more" }],
//     },
//     {
//       type: "taskList",
//       content: [
//         {
//           type: "taskItem",
//           attrs: { checked: false },
//           content: [
//             {
//               type: "paragraph",
//               content: [
//                 { type: "text", text: "Star us on " },
//                 {
//                   type: "text",
//                   marks: [
//                     {
//                       type: "link",
//                       attrs: {
//                         href: "https://github.com/steven-tey/novel",
//                         target: "_blank",
//                       },
//                     },
//                   ],
//                   text: "GitHub",
//                 },
//               ],
//             },
//           ],
//         },
//         {
//           type: "taskItem",
//           attrs: { checked: false },
//           content: [
//             {
//               type: "paragraph",
//               content: [
//                 { type: "text", text: "Install the " },
//                 {
//                   type: "text",
//                   marks: [
//                     {
//                       type: "link",
//                       attrs: {
//                         href: "https://www.npmjs.com/package/novel",
//                         target: "_blank",
//                       },
//                     },
//                   ],
//                   text: "NPM package",
//                 },
//               ],
//             },
//           ],
//         },
//         {
//           type: "taskItem",
//           attrs: { checked: false },
//           content: [
//             {
//               type: "paragraph",
//               content: [
//                 {
//                   type: "text",
//                   marks: [
//                     {
//                       type: "link",
//                       attrs: {
//                         href: "https://vercel.com/templates/next.js/novel",
//                         target: "_blank",
//                       },
//                     },
//                   ],
//                   text: "Deploy your own",
//                 },
//                 { type: "text", text: " to Vercel" },
//               ],
//             },
//           ],
//         },
//       ],
//     },
//   ],
// };

export const defaultEditorContent = {
  type: "doc",
  content: [
    {
      type: "heading",
      attrs: { level: 2 },
      content: [{ type: "text", text: "AlphaPass EPPP Notes" }],
    },
    {
      type: "paragraph",
      content: [
        {
          type: "text",
          text: "Welcome to AlphaPass EPPP Notes - Your comprehensive study companion for the EPPP examination.",
        },
      ],
    },
    {
      type: "heading",
      attrs: { level: 3 },
      content: [{ type: "text", text: "Getting Started" }],
    },
    {
      type: "heading",
      attrs: { level: 3 },
      content: [{ type: "text", text: "Features" }],
    },
    {
      type: "orderedList",
      attrs: { tight: true, start: 1 },
      content: [
        {
          type: "listItem",
          content: [
            {
              type: "paragraph",
              content: [{ type: "text", text: "Rich Text Editing" }],
            },
          ],
        },
        {
          type: "listItem",
          content: [
            {
              type: "paragraph",
              content: [
                { type: "text", text: "AI-powered smart completion (type " },
                { type: "text", marks: [{ type: "code" }], text: "++" },
                {
                  type: "text",
                  text: " to activate)",
                },
              ],
            },
          ],
        },
        {
          type: "listItem",
          content: [
            {
              type: "paragraph",
              content: [
                {
                  type: "text",
                  text: "Image support with drag & drop functionality",
                },
              ],
            },
          ],
        },
        {
          type: "listItem",
          content: [
            {
              type: "paragraph",
              content: [
                {
                  type: "text",
                  text: "Mathematical expressions support:",
                },
              ],
            },
            {
              type: "orderedList",
              attrs: {
                tight: true,
                start: 1,
              },
              content: [
                {
                  type: "listItem",
                  content: [
                    {
                      type: "paragraph",
                      content: [
                        {
                          type: "math",
                          attrs: {
                            latex: "E = mc^2",
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  type: "listItem",
                  content: [
                    {
                      type: "paragraph",
                      content: [
                        {
                          type: "math",
                          attrs: {
                            latex: "a^2 = \\sqrt{b^2 + c^2}",
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    { type: "horizontalRule" },
    {
      type: "heading",
      attrs: { level: 3 },
      content: [{ type: "text", text: "Study Resources" }],
    },
    {
      type: "taskList",
      content: [
        {
          type: "taskItem",
          attrs: { checked: false },
          content: [
            {
              type: "paragraph",
              content: [{ type: "text", text: "Review study materials" }],
            },
          ],
        },
        {
          type: "taskItem",
          attrs: { checked: false },
          content: [
            {
              type: "paragraph",
              content: [{ type: "text", text: "Practice exam questions" }],
            },
          ],
        },
        {
          type: "taskItem",
          attrs: { checked: false },
          content: [
            {
              type: "paragraph",
              content: [
                { type: "text", text: "Complete practice assessments" },
              ],
            },
          ],
        },
        {
          type: "taskItem",
          attrs: { checked: false },
          content: [
            {
              type: "paragraph",
              content: [
                {
                  type: "text",
                  text: "Visually explore concepts with EPPP Knowledge Graphs",
                },
              ],
            },
            {
              type: "image",
              attrs: {
                src: "https://notes.alphapass.ai/kg.png", // Using absolute URL
                alt: "EPPP Knowledge Graph",
                title: "EPPP Knowledge Graph",
                width: null,
                height: null,
              },
            },
          ],
        },
      ],
    },
  ],
};
